<script setup lang="ts">
import type { SwitchRootEmits, SwitchRootProps } from 'reka-ui'
import { SwitchRoot, SwitchThumb, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<SwitchRootProps>()
const emits = defineEmits<SwitchRootEmits>()

const forward = useForwardPropsEmits(props, emits)
</script>

<template>
  <SwitchRoot
    v-bind="forward"
    class="focus-within:border-green-40 data-[state=checked]:bg-green-10 data-[state=unchecked]:bg-stone-green-5 data-[state=checked]:border-green-40 border-green-40 focus-within:shadow-green-40 relative flex h-6 w-10 rounded-full border-2 shadow-sm transition-[background] focus-within:shadow-[0_0_0_1px] focus-within:outline-none"
  >
    <SwitchThumb
      class="bg-green-40 my-auto flex size-4 translate-x-1 items-center justify-center rounded-full text-xs shadow-xl transition-transform will-change-transform data-[state=checked]:translate-x-full"
    />
  </SwitchRoot>
</template>
